import {
  TTimedAuctionTimePeriodData,
  IFetchTimedAuctionTimePeriodResponse,
} from '../types';

/**
 * Transforms the raw timed auction time period data into a structured format.
 */
export function formatTimedAuctionInfoResponse(
  bidData: IFetchTimedAuctionTimePeriodResponse['data']
): TTimedAuctionTimePeriodData {
  if (bidData.biddingWindow) {
    return {
      type: 'ACTIVE',
      biddingWindow: bidData.biddingWindow,
    };
  }

  return {
    type: 'INACTIVE',
    biddingWindowIsAvailable: bidData.biddingWindowIsAvailable,
  };
}
